<template>
  <div>
    <v-card v-if="!loading" class="mt-8 mx-8 pa-4">
      <v-card-actions class="text-left">
        <v-row>
          <v-col cols="12" class="text-left">
            <v-icon class="back-link-icon" x-large @click="$router.push('/classes/index')">mdi-arrow-left</v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-title>مدیریت کلاس {{ onlineClass.title }}</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-checkbox color="black" v-model="selectAllStudentCondition" label="همه"
                        @change="changeSelectionStudent()">
            </v-checkbox>
          </v-col>
          <v-col>
            <v-radio-group v-model="selectionMode" row>
              <v-radio
                  color="black"
                  label="ورود به درس"
                  value="open"
              ></v-radio>
              <v-radio
                  color="success"
                  label="باز کردن درس"
                  value="unlock"
              ></v-radio>
              <v-radio
                  color="error"
                  label="قفل کردن درس"
                  value="lock"
              ></v-radio>
              <v-radio
                  color="primary"
                  label="دیکته"
                  value="dictation"
              ></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="2" class="text-left">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="hover-link mx-1"
                        color="teal"
                        v-bind="attrs"
                        v-on="on" @click="$router.push('/classes/manage/setting/'+onlineClass.id)">mdi-cog
                </v-icon>
              </template>
              <span class="tooltip-text">تنظیمات مدیریت کلاس {{ onlineClass.title }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <v-row v-for="student in students" :key="student.id+'-student'" class="student-container">
              <v-col>
                <v-checkbox color="black" v-model="selectedStudentIds[student.id]" :label="student.name">
                </v-checkbox>
              </v-col>
              <v-col cols="1" v-if="student.notification_count">
                <v-badge :content="student.notification_count" color="error">
                </v-badge>
              </v-col>
              <v-col class="text-right">
                <v-icon
                    @click="selectedStudentInfo === student ? selectedStudentInfo = null :  selectedStudentInfo = student"
                    color="black" class="mt-5">mdi-information
                </v-icon>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="9" v-if="selectionMode === 'dictation'">
            <v-row>
              <v-col v-for="dictation in dictations" cols="2" :key="'dictation-'+dictation.id">
                <v-btn style="letter-spacing: normal" :color="selectedDictation?.id === dictation.id ? 'success' :'grey'" @click="showDictationResult(dictation)">
                  {{ dictation.label }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row class="showSingleDictation" v-if="selectionMode === 'dictation' && selectedDictation">
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <v-row v-if="additionalDictationInfo" class="mt-16">
              <v-col cols="12" style="border-style: solid; border-width: 1px; border-color: #e0e0e0; padding: 10px; border-radius:10px">
                  میانگین امتیاز کل :٪ {{additionalDictationInfo.average_score}}
                <br>
                  تاریخ آخرین دیکته : {{additionalDictationInfo.last_dictation_date_time}}
                <br>
                تعداد کل نت های صحیح : {{additionalDictationInfo.total_correct}}
                <br>
                تعداد کل نت های غلط : {{additionalDictationInfo.total_incorrect}}
              </v-col>
            </v-row>
            <v-row v-if="selectionMode === 'dictation' && selectedDictation">
              <v-col cols="2">
                {{ selectedDictation?.title }}
              </v-col>
              <v-col cols="10">

                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                    <tr>
                      <th class="text-center">تعداد سوال</th>
                      <th class="text-center">میانگین امتیاز ٪</th>
                      <th class="text-center">تعداد تلاش</th>
                      <th class="text-center"> پاسخ صحیح به سوال</th>
                      <th class="text-center"> پاسخ غلط به سوال</th>
                      <th class="text-center">نت درست</th>
                      <th class="text-center">نت غلط</th>
                      <th class="text-center">تاریخ و ساعت</th>
                      <th class="text-center">جزییات دیکته</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td class="text-center">{{selectedDictation.children.length }}</td>
                      <td class="text-center">{{ averageScore }}</td>
                      <td class="text-center">{{ triesCount }}</td>
                      <td class="text-center">{{ successfulTries }}</td>
                      <td class="text-center">{{ unsuccessfulTries }}</td>
                      <td class="text-center">{{totalCorrectCount}}</td>
                      <td class="text-center">{{ totalIncorrectCount }}</td>
                      <td class="text-center">{{ lastDateTimeDictation }}</td>
                      <td class="text-center"><v-icon color="success" @click="openDictation()">mdi-eye</v-icon></td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>



<!--                <v-simple-table>-->
<!--                  <template v-slot:default>-->
<!--                    <thead>-->
<!--                    <tr>-->
<!--                      <th class="text-center">سوال</th>-->
<!--                      <th class="text-center">امتیاز ٪</th>-->
<!--                      <th class="text-center">پاسخ درست</th>-->
<!--                      <th class="text-center">پاسخ غلط</th>-->
<!--                    </tr>-->
<!--                    </thead>-->
<!--                    <tbody>-->
<!--                    <tr v-for="(item, index) in selectedStudentDictationInfo.filter(dictationInstance=>dictationInstance.item_dictation_id === selectedDictation.id)"-->
<!--                        :key="index">-->
<!--                      <td class="text-center">{{ index+1}} سوال</td>-->
<!--                      <td class="text-center">{{ parseInt((item.correct_count * 100) / (item.correct_count + item.incorrect_count))}}</td>-->
<!--                      <td class="text-center">{{item.correct_count }}</td>-->
<!--                      <td class="text-center">{{item.incorrect_count }}</td>-->
<!--                    </tr>-->
<!--                    </tbody>-->
<!--                  </template>-->
<!--                </v-simple-table>-->
              </v-col>
            </v-row>
          </v-col>

          <v-col v-else-if="!studentInfoLoading" cols="9" class="text-center">
            <v-row>
              <v-col cols="12">
                {{ selectedStudentInfo }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="1" class="custom-margin-lessons" v-for="(lesson,index) in lessons"
                     :key="lesson.id+'-lesson'">
                <v-tooltip bottom v-if="selectionMode === 'lock'">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        class="pa-0"
                        v-bind="attrs"
                        v-on="on"
                        :color="selectedStudentLessonsInfo.filter(lessonInfo => lessonInfo.item_id === lesson.id)[0].status === 'close'? 'error' : ''"
                    >
                      <div v-if="selectedStudentLessonsInfo">
                        <v-icon
                            x-small
                            v-if="selectedStudentLessonsInfo.filter(lessonInfo => lessonInfo.item_id === lesson.id)[0].status === 'open'">
                          mdi-lock-open-variant-outline
                        </v-icon>
                        <v-icon v-else x-small>
                          mdi-lock
                        </v-icon>
                      </div>
                      <v-checkbox
                          color="black" v-model="selectedLessonIds[lesson.id]" :label="String(index+1)">
                      </v-checkbox>
                    </v-btn>
                  </template>
                  <span class="tooltip-text">{{ lesson.title }}</span>
                </v-tooltip>
                <v-tooltip bottom v-if="selectionMode === 'unlock'">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        class="pa-0"
                        v-bind="attrs"
                        v-on="on"
                        :color="selectedStudentLessonsInfo.filter(lessonInfo => lessonInfo.item_id === lesson.id)[0].status === 'open'? 'success' : ''"
                    >
                      <div v-if="selectedStudentLessonsInfo">
                        <v-icon
                            x-small
                            v-if="selectedStudentLessonsInfo.filter(lessonInfo => lessonInfo.item_id === lesson.id)[0].status === 'open'">
                          mdi-lock-open-variant-outline
                        </v-icon>
                        <v-icon v-else x-small>
                          mdi-lock
                        </v-icon>
                      </div>
                      <v-checkbox
                          color="black" v-model="selectedLessonIds[lesson.id]" :label="String(index+1)">
                      </v-checkbox>
                    </v-btn>
                  </template>
                  <span class="tooltip-text">{{ lesson.title }}</span>
                </v-tooltip>
                <v-tooltip bottom v-if="selectionMode === 'open'">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        class="pa-1"
                        v-bind="attrs"
                        v-on="on"
                        @click="selectedStudentId ? $router.push('/classes/manage/item/show/'+onlineClass.id+'/'+lesson.id+'/'+selectedStudentId) : null"
                    >
                      <div class="ml-4" v-if="selectedStudentLessonsInfo">
                        <v-badge
                            v-if="selectedStudentLessonsInfo.filter(lessonInfo => lessonInfo.item_id === lesson.id)[0].notification_count"
                            :content="selectedStudentLessonsInfo.filter(lessonInfo => lessonInfo.item_id === lesson.id)[0].notification_count"
                            color="error">
                        </v-badge>
                      </div>
                      <div v-if="selectedStudentLessonsInfo">
                        <v-icon
                            v-if="selectedStudentLessonsInfo.filter(lessonInfo => lessonInfo.item_id === lesson.id)[0].status === 'open'">
                          mdi-lock-open-variant-outline
                        </v-icon>
                        <v-icon v-else>
                          mdi-lock
                        </v-icon>
                      </div>
                      {{ String(index + 1) }}
                    </v-btn>
                  </template>
                  <span class="tooltip-text">{{ lesson.title }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-center mt-6">
                <v-btn style="letter-spacing: normal!important" color="error" class="white--text"
                       v-if="selectionMode === 'lock'" @click="lockLesson()">
                  قفل شود
                </v-btn>
                <v-btn style="letter-spacing: normal!important" color="success" class="white--text"
                       v-if="selectionMode === 'unlock'" @click="unlockLesson()">
                  باز شود
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col v-else cols="9" class="text-center">
            <v-progress-circular
                indeterminate
                color="black"
                size="200"
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-progress-circular
        v-else
        :rotate="360"
        :size="200"
        :width="15"
        color="success"
        style="position:fixed!important ; z-index: 10 ; top:35vh!important ; left:49vw!important;"
    >
      لطفا منتظر باشید.
    </v-progress-circular>
  </div>
</template>

<script>
export default {
  name: "OnlineClassManageIndex",
  data() {
    return {
      loading: true,
      studentInfoLoading: false,
      selectionMode: 'open',
      onlineClass: [],
      lessons: [],
      dictations: [],
      students: [],
      instructors: [],
      selectedStudentInfo: null,
      selectedStudentId: null,
      selectedStudentLessonsInfo: null,
      selectedStudentDictationInfo: null,
      selectedStudentIds: [],
      selectedLessonIds: [],
      selectAllStudentCondition: false,
      selectedDictation: null,
      additionalDictationInfo : null,
    }
  },
  computed: {
    successfulTries() {
      const dictationItems = this.selectedStudentDictationInfo.filter(
          (dictationInstance) => dictationInstance.item_dictation_id === this.selectedDictation.id
      );

      // Count records where status is "correct"
      return dictationItems.filter(item => item.status === "correct").length;
    },
    unsuccessfulTries() {
      const dictationItems = this.selectedStudentDictationInfo.filter(
          (dictationInstance) => dictationInstance.item_dictation_id === this.selectedDictation.id
      );

      // Count records where status is "incorrect"
      return dictationItems.filter(item => item.status === "incorrect").length;
    },
    triesCount() {
      // Filter the items related to the selected dictation
      const dictationItems = this.selectedStudentDictationInfo.filter(
          (dictationInstance) => dictationInstance.item_dictation_id === this.selectedDictation.id
      );

      // Find the record with the largest tries value
      if (dictationItems.length > 0) {
        const highestTriesDictation = dictationItems.reduce((max, current) =>
            max.tries > current.tries ? max : current
        );
        return highestTriesDictation.tries; // Return the tries value of the record with the largest tries count
      }

      // Default return if no dictation items found
      return 0;
    },
    lastDateTimeDictation(){

      // Filter the items related to the selected dictation
      const dictationItems = this.selectedStudentDictationInfo.filter(
          (dictationInstance) => dictationInstance.item_dictation_id === this.selectedDictation.id
      );

      // Extract the latest date based on the created_at field
      if (dictationItems.length > 0) {
        const latestDictation = dictationItems.reduce((latest, current) => {
          const latestDate = new Date(latest.created_at);
          const currentDate = new Date(current.created_at);
          return latestDate > currentDate ? latest : current;
        });
        return latestDictation.created_at_fa; // Return the latest created_at field
      }

      // Default return if no dictation items found
      return "N/A";
    },
    averageScore() {
      // Filter the items related to the current dictation first.
      const dictationItems = this.selectedStudentDictationInfo.filter(
          (dictationInstance) => dictationInstance.item_dictation_id === this.selectedDictation.id
      );

      // Calculate the total score and return the average
      const totalScores = dictationItems.reduce((sum, item) => {
        const score = parseInt((item.correct_count * 100) / (item.correct_count + item.incorrect_count));
        return sum + score;
      }, 0);

      // Calculate average and return, avoid division by zero
      return dictationItems.length > 0 ? parseInt(totalScores / dictationItems.length) : 0;
    },

    totalCorrectCount() {
      // Filter the items related to the current dictation first.
      const dictationItems = this.selectedStudentDictationInfo.filter(
          (dictationInstance) => dictationInstance.item_dictation_id === this.selectedDictation.id
      );

      // Sum up the correct_count
      return dictationItems.reduce((sum, item) => sum + item.correct_count, 0);
    },
    totalIncorrectCount() {
      // Filter the items related to the current dictation first.
      const dictationItems = this.selectedStudentDictationInfo.filter(
          (dictationInstance) => dictationInstance.item_dictation_id === this.selectedDictation.id
      );

      // Sum up the incorrect_count
      return dictationItems.reduce((sum, item) => sum + item.incorrect_count, 0);
    },
  },
  async mounted() {
    await this.getOnlineClass()
    if (this.$route.params.studentId) {
      this.selectedStudentIds[this.$route.params.studentId] = true
      let counter = 0
      this.selectedStudentIds.forEach((item) => {
        if (item) {
          counter++
        }
      })
      if (counter === 1) {
        this.selectedStudentIds.forEach((item, index) => {
          if (item) {
            this.studentInfoLoading = true
            this.getStudentInfo(index)
          }
        })
      } else {
        this.selectedStudentLessonsInfo = null
      }
    }
  },
  watch: {
    'selectedStudentIds'() {
      let counter = 0
      this.selectedStudentIds.forEach((item) => {
        if (item) {
          counter++
        }
      })
      if (counter === 1) {
        this.selectedStudentIds.forEach((item, index) => {
          if (item) {
            this.studentInfoLoading = true
            this.getStudentInfo(index)
          }
        })
      } else {
        this.selectedStudentLessonsInfo = null
      }
    }
  },
  methods: {
    openDictation(){
      let baseUrl = process.env.VUE_APP_FRONT_URL
      window.open(baseUrl + 'classes/manage/dictation/single/show/' + this.onlineClass.id+'/'+this.selectedDictation.id+'/'+this.selectedStudentId , "", "width:800,height=800")
    },
    showDictationResult(dictation) {
      this.selectedDictation = dictation
    },
    async getOnlineClass() {
      try {
        let url = '/class/crud/get/' + this.$route.params.id;
        const response = await window.axios.get(url);
        this.onlineClass = response.data.data;
        await this.getData();
      } catch (err) {
        this.openSnackbar(err.response.data.message, '#F1416C');
      }
    },
    async getData() {
      try {
        const res = await window.axios.get('class/crud/relations/' + this.$route.params.id);
        this.students = res.data.data.students;
        this.instructors = res.data.data.instructors;
        this.lessons = res.data.data.lessons;
        this.dictations = res.data.data.dictations
        this.loading = false;
      } catch (err) {
        this.openSnackbar(err.response.data.message, '#F1416C');
      }
    },
    changeSelectionStudent() {
      if (this.selectAllStudentCondition) {
        this.students.forEach((item) => {
          this.$set(this.selectedStudentIds, item.id, true)
        })
      } else {
        this.selectedStudentIds = []
      }
    },
    getStudentInfo(studentId) {
      this.selectedStudentId = studentId
      window.axios.post('class/manage/student/info', {
        student_id: studentId,
        course_id: this.onlineClass.course_id,
        online_class_id: this.onlineClass.id
      }).then((res) => {
        this.studentInfoLoading = false
        this.selectedStudentLessonsInfo = res.data.data.lesson_info
        this.selectedStudentDictationInfo = res.data.data.dictations_info
        this.additionalDictationInfo = res.data.data.dictation_additional_info
      })
    },
    lockLesson() {
      if (!this.selectedStudentIds.length) {
        this.openSnackbar('شما هنرجویی را انتخاب نکرده اید.', 'error')
        return
      }
      if (!this.selectedLessonIds.length) {
        this.openSnackbar('شما درسی را انتخاب نکرده اید.', 'error')
        return
      }
      this.loading = true
      window.axios.post('class/manage/lock/' + this.onlineClass.id, {
        course_id: this.onlineClass.course_id,
        student_ids: this.selectedStudentIds,
        lesson_ids: this.selectedLessonIds,
      }).then(() => {
        this.selectAllStudentCondition = false
        // this.selectedStudentIds = []
        this.selectedLessonIds = []
        // this.selectionMode = 'open'
        this.getStudentInfo(Object.keys(this.selectedStudentIds)[0])
        this.openSnackbar('درس مورد نظر برای هنرجویان با موفقیت قفل شد.', 'success')
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#FB4E4E')
      }).finally(() => {
        this.loading = false
      })
    },
    unlockLesson() {
      if (!this.selectedStudentIds.length) {
        this.openSnackbar('شما هنرجویی را انتخاب نکرده اید.', 'error')
        return
      }
      if (!this.selectedLessonIds.length) {
        this.openSnackbar('شما درسی را انتخاب نکرده اید.', 'error')
        return
      }
      this.loading = true
      window.axios.post('class/manage/unlock/' + this.onlineClass.id, {
        course_id: this.onlineClass.course_id,
        student_ids: this.selectedStudentIds,
        lesson_ids: this.selectedLessonIds,
      }).then(() => {
        this.selectAllStudentCondition = false
        // this.selectedStudentIds = []
        this.selectedLessonIds = []
        // this.selectionMode = 'open'
        this.getStudentInfo(Object.keys(this.selectedStudentIds)[0])
        this.openSnackbar('درس مورد نظر برای هنرجویان با موفقیت باز شد.', 'success')
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#FB4E4E')
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.student-container {
  background-color: whitesmoke !important;
  border-radius: 10px !important;
}

.custom-margin-lessons {
  margin-top: -1vh !important;
  margin-left: -1vw !important;
}

.showSingleDictation {
  margin-top: 20vh;
}
</style>